import { createFileRoute } from "@tanstack/react-router";

import {
  parseRev,
  parseTab,
  type AnnotateSearch,
} from "../../../workspaces/label/annotate-search";
import { AnnotatePage } from "../../../workspaces/label/pages/AnnotatePage";
import { RequirementEntry } from "../../../workspaces/label/pages/RequirementEntry";
import { useSeat } from "../../../workspaces/label/seat";

/* The workbench. `?tab=` and `?rev=` are its URL state and they arrive from
 * bookmarks the floor has had open for weeks, so they are parsed once here into
 * a total record: an unknown tab is the Task tab (the mandatory first stop since
 * the jinga/Jenga incident) and an unreadable revision is "not chosen yet",
 * which the page resolves to the draft or the newest revision. */
export const Route = createFileRoute("/_console/label/annotate/$episodeId")({
  validateSearch: (search: Record<string, unknown>): AnnotateSearch => ({
    tab: parseTab(search.tab),
    rev: parseRev(search.rev),
    requirementId: typeof search.requirementId === "string" && search.requirementId.trim()
      ? search.requirementId : undefined,
    legacy: search.legacy === true,
  }),
  component: Annotate,
});

function Annotate() {
  const { episodeId } = Route.useParams();
  const search = Route.useSearch();
  const seat = useSeat();
  return !search.requirementId && (search.legacy || search.tab !== undefined || search.rev !== undefined)
    ? <AnnotatePage user={seat} />
    : <RequirementEntry episodeId={episodeId} requirementId={search.requirementId} user={seat} />;
}
